export default __webpack_public_path__ + "static/media/regulatory--cross-only-on-pedestrian-signal--g1.a36a6a28.png";